import { AppLauncher } from '@capacitor/app-launcher';
import { environment } from 'src/environments/environment';

let lastOpenedUrl = '';
let lastOpenedAt = 0;

export function apkFileProxyUrl(fileUrl: string): string | null {
  const match = String(fileUrl || '').match(
    /\/apk\/(apk|release)\/([^/?#]+\.(?:apk|aab))(?:\?|#|$)/i,
  );
  if (!match) return null;
  return `${environment.apiUrl}/apk-download/${match[1]}/${encodeURIComponent(match[2])}`;
}

export async function openUrlInAndroidChrome(url: string): Promise<boolean> {
  const target = apkFileProxyUrl(url) || url;
  const now = Date.now();
  if (target === lastOpenedUrl && now - lastOpenedAt < 2500) {
    return true;
  }
  lastOpenedUrl = target;
  lastOpenedAt = now;

  try {
    const result = await AppLauncher.openUrl({ url: target });
    return !!result.completed;
  } catch {
    return false;
  }
}
